import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import 'styleguide/styleguide-ds2-output.css'
import React from 'react';
import { detectEnvironmentFromUrl, getEnvironmentConfig } from './utils/detectEnv';


console.log('React app starting...');

console.log('React app starting...');

// ============================================
// Detect Environment from URL
// ============================================

const detectedEnv = detectEnvironmentFromUrl();
const envConfig = getEnvironmentConfig();

console.log('Environment Detection:');
console.log(' Detected Environment:', detectedEnv);

// Store globally
(globalThis as any).detectedEnv = detectedEnv;
(globalThis as any).envConfig = envConfig;

// Defensive wrapper: swallow NotFoundError from removeChild when third-party
// library attempts to remove nodes that React already removed.
// This prevents uncaught NotFoundError originating from `tabs-pattern` or similar libs.
if (typeof Node !== 'undefined' && Node.prototype && !((Node.prototype as any).__removeChildPatched)) {
  const originalRemoveChild = Node.prototype.removeChild;
  (Node.prototype as any).removeChild = function (child: Node) {
    try {
      return originalRemoveChild.call(this, child);
    } catch (err: any) {
      // If it's the specific NotFoundError from removeChild, swallow it.
      if (err && (err.name === 'NotFoundError' || /not a child of this node/i.test(err.message ?? ''))) {
        // eslint-disable-next-line no-console
        console.warn('Suppressed removeChild NotFoundError:', err.message ?? '');
        return child; // no-op return
      }
      throw err;
    }
  };
  (Node.prototype as any).__removeChildPatched = true;
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);